import { isStringArray } from "graphql/helpers/queryHelpers";

const USER_FEATURE_FLAG_TYPES = [] as const;
export type UserFeatureFlagType = (typeof USER_FEATURE_FLAG_TYPES)[number];

const isKnownUserFeatureFlagType = (
    type: string
): type is UserFeatureFlagType => {
    return USER_FEATURE_FLAG_TYPES.includes(type as UserFeatureFlagType);
};

const convertToUserFeatureFlagType = (string: string): UserFeatureFlagType => {
    if (isKnownUserFeatureFlagType(string)) {
        return string;
    }

    throw new Error("Unexpected user feature flag");
};

export const convertToUserFeatureFlagTypeList = (
    hasuraObject: unknown
): ReadonlyArray<UserFeatureFlagType> => {
    if (!isStringArray(hasuraObject)) {
        throw new Error("Expected array of strings");
    }

    const listOfStrings: string[] = hasuraObject;
    const validFeatureFlags: UserFeatureFlagType[] = listOfStrings
        .filter(isKnownUserFeatureFlagType)
        .map(convertToUserFeatureFlagType);

    return validFeatureFlags;
};
